export default {
  message: {
    "error": "Ups! Sesuatu telah salah.",
    "Sorrysomeerrorsoccurred": "Terjadi kesalahan yang tidak terduga. Anda dapat mencoba mengganti bahasa atau keluar dan memulai ulang aplikasi.",
    "quit": "Keluar",
    "language": "Bahasa",
    "Youcanchangethelanguagehere": "Anda dapat mengubah bahasa di sini!",
    "current": "Saat ini",
    "home": "Beranda",
    "friends": "Teman",
    "wallet": "Dompet",
    "aboutus": "Tentang Kami",
    "Sharewithfriends": "Bagikan dengan teman",
    "copyFailure": "Gagal Menyalin",
    "copySuccess": "Berhasil Menyalin",
    "Claimreward": "Terima hadiah",
    "DailyLogin": "Login Harian",
    "noInvitationsYet": "Belum Ada Undangan",
    "LoadMore": "Muatan Lebih",
    "WatchAD": "Tonton Iklan",
    "continue": "Lanjutkan",
    "Congratulations": "Selamat",
    "MyFriends": "Teman-Teman Saya",
    "Invitefriends": "Undang teman",
    "Invitepremiumfriends": "Undang teman premium",
    "DailyTasks": "Tugas harian",
    "inviteDesc": "+{num} ${name} untuk setiap teman yang Anda undang",
    "DailyTasksDesc": "Selesaikan tugas untuk mendapatkan lebih banyak airdrop",
    "SponsorsandPartners": "Sponsor dan Mitra",
    "Receivingwallet": "Dompet penerima",
    "Enterwalletaddress": "Masukkan alamat dompet {name}",
    "Claim": "Terima",
    "Booster": "Pendorong",
    "RentPeriod": "Jangka Waktu Sewa",
    "days30": "30 hari",
    "Dailyprofit": "Keuntungan harian",
    "Totalprofit": "Jumlah total keuntungan",
    "Quantity": "Kuantitas",
    "RentPrice": "Harga Sewa",
    "RentMiner": "Sewa Penambang",
    "Insufficient": "Jumlah undangan tidak mencukupi",
    "InsufficientMsg": "Anda perlu mengundang {num} teman untuk mendapatkan lebih banyak aksesori.",
    "Settings": "Pengaturan",
    "copyid": "Salin ID",
    "UpgradeSuccessfully": "Pembaruan Berhasil",
    "Name": "Nama",
    "userinfo": "Informasi pengguna",
    "disconnect": "Putuskan sambungan",
    "Startmining": "Mulai menambang",
    "Welcome": "Selamat datang di {name}",
    "Withdrawal": "Pencairan",
    "Minimumamount": "Jumlah minimum",
    "Networkfee": "Biaya jaringan",
    "Enteramount": "Masukkan jumlah",
    "Submit": "Kirim",
    "MinimumTip": "Jumlah penarikan terlalu kecil. Jumlah penarikan minimum: {num}",
    "MaximumTip": "Jumlah tidak cukup, jumlah maksimum yang dapat Anda tarik adalah: {num}",
    "SubmittedTip": "Dikirim, diharapkan diproses dalam 30-60 hari kerja",
    "WithdrawStatus": "Status",
    "Submissiontime": "Waktu pengiriman",
    "WithdrawAwaitTip": "* Diperkirakan membutuhkan waktu 30-60 hari kerja. Mengundang lebih banyak teman dapat mempercepat proses ulasan.",
    "Processing": "Memproses",
    "Amount": "Jumlah",
    "Numberoffriends": "Jumlah teman: {now}/{limit}",
    "InviteTip": "Untuk melakukan penarikan pertama Anda, Anda perlu mengundang {limit} teman untuk bergabung dengan aplikasi penambangan.",
    "openonphone": "Buka tautan ini di ponsel Anda.",
    "claimTip": "Jumlah yang dapat diklaim terlalu kecil. Jumlah minimum yang dapat diklaim adalah: {num}",
    "WalletBalance": "Saldo Dompet",
    "Withdraw": "Tarik",
    "SetWalletAddress": "Atur Alamat Dompet",
    "WithdrawalRecord": "Catatan Penarikan",
    "Norecords": "Tidak ada catatan",
    "Whatis": "Apa itu {name}?",
    "All": "Semua",
    "save": "Simpan",
    "successWithdrawal": "Scan berhasil {num}",
    "secondsago": "{time} detik yang lalu",
    "Loading": "Memuat...",
    "PaymentConfirming": "Memeriksa Status Transaksi...",
    "Check": "Periksa",
    "CheckFail": "Transaksi belum selesai. Silakan periksa lagi dalam 5 detik.",
    "Addname": "Tambahkan '{name}' ke nama Anda",
    "Restattcheck": "Mulai ulang aplikasi untuk memeriksa",
    "Copyname": "Salin '{name}'",
    "SubmissionFailed": "Pengiriman gagal, silakan coba lagi nanti",
    "WithdrawalReview": "Ulasan penarikan",
    "WebWithdrawAwaitTip": "* Diperkirakan membutuhkan waktu 24-48 jam. Mengundang lebih banyak teman dapat mempercepat proses ulasan.",
    "Success": "Berhasil",
    "Rejection": "Penolakan",
    "WebSubmittedTip": "Dikirim, kami akan memprosesnya sesegera mungkin.",
    "select_payment_method": "Pilih metode pembayaran",
    "total_amount": "Jumlah total",
    "next_step": "Langkah selanjutnya",
    "creating_order": "Membuat pesanan...",
    "order_created": "Pesanan dibuat",
    "order_status": "Status pesanan",
    "order_id": "ID Pesanan",
    "order_amount": "Jumlah pesanan",
    "order_status_desc": "Deskripsi status pesanan",
    "payment_cancelled": "Pembayaran dibatalkan",
    "opening_payment": "Membuka pembayaran...",
    "payment_success": "Pembayaran berhasil",
    "payment_failed": "Pembayaran gagal",
    "payment_pending": "Pembayaran tertunda",
    "payment_processing": "Pembayaran diproses",
    "create_order_failed": "Gagal membuat pesanan",
    "creating_ton_order": "Membuat pesanan TON...",
    "check_payment_status": "Mengecek status pembayaran...",
    "use_ton_payment": "Gunakan pembayaran TON",
    "connect_wallet": "Hubungkan dompet",
    "start_transaction": "Mulai transaksi",
    "address": "Alamat",
    "amount_ton": "Jumlah TON",
    "copy": "Salin",
    "comment_memo": "Komentar memo",
    "comment_memo_desc": "Silakan masukkan komentar memo",
    "comment_memo_placeholder": "Masukkan komentar memo",
    "amount": "Jumlah",
    "wallet_address": "Alamat dompet",
    "you_can_choose_to_connect_wallet_to_pay": "Anda dapat memilih untuk menghubungkan dompet untuk membayar",
    "or_manually_transfer_to_the_above_address": "Atau mentransfer secara manual ke alamat di atas (perhatikan bahwa jumlah dan memo harus sama persis)",
    "transaction_success": "Transaksi sukses",
    "transaction_failed": "Transaksi gagal",
    "transaction_error": "Kesalahan transaksi",
    "transaction_status": "Status transaksi",
    "transaction_id": "ID transaksi",
    "transaction_amount": "Jumlah transaksi",
    "transaction_status_desc": "Deskripsi status transaksi",
    "miner_detail": "Detail miner",
    "rent_period": "Periode sewa",
    "days": "{days} hari",
    "daily_yield": "Hasil harian",
    "total_yield": "Total hasil",
    "invite_friends": "Undang teman",
    "price": "Harga",
    "rent": "Sewa",
    "free_claim": "Klaim gratis",
    "redeem": "Tukarkan",
    "buy": "Sewa",
    "invite_friends_not_enough": "Undang teman tidak cukup",
    "redeem_success": "Tukarkan sukses",
    "redeem_failed": "Tukarkan gagal",
    "rent_success": "Sewa sukses",
    "rent_failed": "Sewa gagal",
    "TotalPower": "Total Daya",
    "MaxQuantity": "Nilai maksimum tercapai",
    "Running": "Berjalan",
    "Stop": "Hentikan",
    "Withdrawalunlock": "Pembukaan penarikan",
    "Close": "Tutup",
    "Delivering": "Pengiriman",
    "Duetothelargenumber": "Karena jumlah penerima yang besar, airdrop Anda diharapkan tiba dalam 15-20 hari kerja",
    "WithdrawalunlockTip": "Anda perlu {num} teman yang diundang untuk menyelesaikan tugas/mengikat dompet untuk membuka kunci penarikan",
    "mining_title": "Robot",
    "Upgrade": "Upgrade",
    "partner": "Mitra",
    "faq": "FAQ",
    "task": "Tugas",
    "OpenRobot": "Buka Robot",
    "MyRobot": "Robot Saya",
    "Level": "Tingkat",
    "Commission": "Komisi",
    "DirectFriends": "Teman Langsung",
    "Feedback": "Umumkan Umpan Balik",
    "Pleaseenteryouremailaddress": "Silakan masukkan alamat email Anda",
    "Inputfeedbackcontent": "Masukkan konten umpan balik",
    "Submitfeedback": "Kirim umpan balik",
    "Feedbacksubmittedsuccessfully,thankyouforyourvaluablefeedback": "Umpan balik berhasil dikirim, terima kasih atas umpan balik berharga Anda",
    "Feedbacksubmissionfailed,pleaseretriy": "Kirim umpan balik gagal, silakan coba lagi",
    "Addressformaterror": "Kesalahan format alamat",
    "Readclipboardfailed": "Gagal membaca clipboard",
    "Youhavealreadyfeedbackedtoday,pleasecomebacktomorrow": "Anda sudah memberikan umpan balik hari ini, silakan kembali besok",
    "Record": "Rekam",
    "Newuserguidance": "Lihat Tur Selamat Datang",
    "Usetonwallet": "Gunakan dompet TON",
    "Reward": "Hadiah",
    "Connectwallet": "Sambungkan dompet",
    "Notconnected": "Tidak terhubung",
    "Disconnect": "Putuskan sambungan",
    "AboutTAI": "Detail Token",
    "WithdrawalRecordDesc": "Rekam penarikan",
    "StartAItrading": "Mulai perdagangan AI",
    "Next": "Selanjutnya",
    "Start": "Mulai",
    "WithdrawalSuccess": "Penarikan berhasil",
    "WithdrawalFail": "Penarikan gagal",
    "Max": "Maks",
    "WithdrawalRecords": "Rekaman Penarikan",
    "Commissionrules": "Aturan komisi",
    "Mycommission": "Komisi saya",
    "Shop": "Toko",
    "BuyDifferentAIrobots": "Upgrade dengan perangkat komputasi untuk pemindaian yang lebih cepat!",
    "CurrentRunningAIrobots": "Robot AI yang sedang berjalan",
    "DailyProfit": "Keuntungan harian",
    "Buy": "Beli",
    "ValidityPeriod": "Periode validitas",
    "Days": "Hari",
    "Price": "Harga",
    "APY": "APY",
    "NoRobot": "Tidak ada daya komputasi",
    "RemainingTime": "Sisa waktu",
    "InviteandEarn": "Undang dan dapatkan",
    "InvitDec": "Undang teman-teman Anda untuk bergabung dengan trading AI dan dapatkan komisi USDT serta token airdrop bersama!",
    "ShareToGroups": "Bagikan ke grup",
    "Select_payment_method": "Pilih metode pembayaran",
    "twa_pay_tip_with_memo": "Silakan pastikan alamat, jumlah, dan memo konsisten untuk transfer.",
    "twa_pay_tip": "Silakan pastikan alamat dan jumlah benar untuk transfer.",
    "twa_pay_tip_placeholder": "Masukkan memo komentar",
    "twa_pay_tip_placeholder_with_memo": "Masukkan memo komentar dengan memo",
    "twa_pay_tip_placeholder_without_memo": "Masukkan memo komentar tanpa memo",
    "twa_pay_tip_placeholder_with_memo_placeholder": "Masukkan memo komentar dengan memo",
    "twa_pay_tip_placeholder_without_memo_placeholder": "Masukkan memo komentar tanpa memo",
    "realtime_ai": "Trading AI Waktu Nyata",
    "check_transaction_status": "Periksa status transaksi",
    "transaction_wait": "Transaksi sedang diproses. Anda dapat keluar dari aplikasi. Sebuah pesan akan memberi tahu Anda setelah selesai.",
    "Pleaseenteravalidemailaddress": "Silakan masukkan alamat email yang valid",
    "max_robot_tip": "Batas pembelian tercapai — coba rencana lain untuk terus berdagang!",
    "connectFailure": "Koneksi dompet gagal",
    "connectSuccess": "Koneksi dompet berhasil",
    "PayNow": "Bayar Sekarang",
    "min_withdrawal_amount": "Jumlah penarikan minimum adalah {num} {coin_name}",
    "max_withdrawal_amount": "Jumlah penarikan maksimum adalah {num} {coin_name}",
    "balance_not_enough": "Anda tidak memiliki saldo yang cukup untuk penarikan ini.",
    "Numberofgroups": "Jumlah grup: {now}/{limit}",
    "Withdraw_success": "Penarikan berhasil",
    "allProfit": "Total untung",
    "AnnualProfit": "Keuntungan tahunan",
    "ScanWallet": "Scan Dompet",
    "wallet_check": "wallet_check",
    "Found": "Ditemukan",
    "ScanSpeed": "Kecepatan pemindaian",
    "MyComputingPower": "Komputasi",
    "Scanning": "Memindai!",
    "WithdrawDetail": "Rincian penarikan",
    "ScanSuccess": "Rasio keberhasilan pemindaian Anda telah meningkat!",
    "TaskDescription": "Selesaikan tugas untuk meningkatkan tingkat keberhasilan pemindaian Anda!",
    "InitializingMiningSystem": "Memulai sistem pemindaian...",
    "NoWithdrawalRecord": "Tidak ada catatan penarikan",
    "Invite": "Undangan yang diperlukan",
    "Free": "Gratis",
    "Confirm": "Konfirmasi",
    "RefreshTasks": "Segarkan tugas",
    "NumberofGroups": "Jumlah grup: {now}/{limit}",
    "SendMessage": "Kirim pesan",
    "NumberofShares": "Jumlah saham: {now}/{limit}",
    "NumberofTasks": "Jumlah tugas: {now}/{limit}",
    "CompleteTask": "Selesaikan tugas",
    "Accelerated": "Dipercepat",
    "Accelerated_withdrawals_success": "Penarikan yang dipercepat berhasil",
    "GoBuy": "Belanja Sekarang",
    "SpeedUpScan": "Percepat",
    "Earnings": "Pembayaran",
    "learnMore": "Pelajari lebih lanjut",
    "claimSuccess": "Hadiah berhasil dikumpulkan",
    "claimFailed": "Pengumpulan hadiah gagal, silakan coba lagi",
    "noDividends": "Tidak ada dividen untuk dikumpulkan",
    "dividendsInfoFallback": "Undang teman untuk mendapatkan hadiah referral"
}};